module.exports = __webpack_public_path__ + "static/img/b7-1.f1781e8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/product/b7-1.png
// module id = uPGq
// module chunks = 1